/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ILayoutConfig, LAYOUT_TYPE } from "../../../ui/components/Layout/LayoutTypes";

export const AssetEditLayoutConfig: ILayoutConfig = {
	root: {
		type: LAYOUT_TYPE.ROW,
		id: "layout",
		children: [
			{
				type: LAYOUT_TYPE.PANEL,
				id: "main",
				isExpandable: false,
				toolbarComponent: "toolbar",
				secondaryToolbarComponent: "secondaryToolbar",
				contentComponent: "main"
			},
			{
				type: LAYOUT_TYPE.SPLITTER,
				id: "rightSplitter"
			},
			{
				type: LAYOUT_TYPE.TABS,
				id: "panelRight",
				size: "250px",
				isExpandable: true,
				defaultExpanded: true,
				defaultTabIndex: 0,
				tabs: [
					{
						id: "info",
						label: "Info",
						contentComponent: "assetInfo",
						renderWhenHidden: false
					}
				]
			}
		]
	}
};
